import { Injectable } from "@angular/core";
import { UsuarioServiceProvider } from "../usuario-service/usuario-service";
//! todo
// import { NativePageTransitions,	NativeTransitionOptions,} from "@ionic-native/native-page-transitions/ngx";
import { Observable, Subject, BehaviorSubject, Subscription  } from "rxjs";
import { environment } from "src/environments/environment";
import { Platform } from "@ionic/angular";
import { LanguageService } from "../language-service/language.service";
import { CalendarService } from "../calendar-service/calendar.service";
import { AppPlatformService } from "../platform/app-platform.service";
// export interface Paginas {
// 	name: string;
// 	path: string;
// 	icon?: string;
// }
@Injectable({ providedIn: "root" })
export class FuncionesServiceProvider {
	private ruta_imagen: string;
	public mod_evaluaciones: any = [];
	cargar_al_iniciar: number = 0;
	renovar_token: boolean = false;
	private timeCod: any = 0;

	private pages: any[];
	private groupedPages: any[];
	finalMenu: any= [];
	private pages$ = new Subject<any[]>();

	private mainPages = [];
	private appMainMenu = new Subject<any[]>();
  public appMainMenu$ = this.appMainMenu.asObservable();

  menuGradientActive:boolean = true;

  private alternativeStyleSubject = new BehaviorSubject<boolean | null>(null);
  alternativeStyleSubject$ = this.alternativeStyleSubject.asObservable();
  brandColors = {
    primary: "",
    secondary: "",
    tertiary: "",
  };

  private headerPages = new BehaviorSubject([]);
  headerPages$ = this.headerPages.asObservable();
  language:string = "es";
  private rankingIsActive = new BehaviorSubject<boolean>(false);
  rankingIsActive$ = this.rankingIsActive.asObservable();
  private courseIsActive = new BehaviorSubject<boolean>(false);
  courseIsActive$ = this.courseIsActive.asObservable();
  private loadingScreenIsActive = new BehaviorSubject<boolean>(false);
  loadingScreenIsActive$ = this.loadingScreenIsActive.asObservable();
  private calendarSub: Subscription;
  private calendarIsAvailable: boolean = false;


	constructor(
		public up: UsuarioServiceProvider,
    private platform: Platform,
    private languageService: LanguageService,
    private calendarService: CalendarService,
    private appPlatformService: AppPlatformService
		// private nativePageTransitions: NativePageTransitions
	) {
    const alternativeStyle = localStorage.getItem("appAlternativeStyle");
    if (alternativeStyle) {
      this.alternativeStyleSubject.next(JSON.parse(alternativeStyle));
    };

    if (environment.APP_MULTIMARCA || environment.SERVICE_BASE.includes("test5")) this.subLanguageConfig();
    if (this.calendarSub) this.calendarSub.unsubscribe();
    this.calendarSub = this.calendarService.calendarIsAvailable$.subscribe(isAvailable => {
      this.calendarIsAvailable = isAvailable;
    });
  }

  subLanguageConfig() {
    this.languageService.getCurrentLang().subscribe(lang => {
      const currentLang = this.language;
      this.language = lang;
      if(currentLang !== this.language) {
        this.cargarFunciones();
      }
    });
  }

	public transitionsPush(direccion) {
    //! todo
		// let options: NativeTransitionOptions = {
		// 	direction: direccion,
		// 	duration: 800,
		// 	slowdownfactor: 3,
		// 	slidePixels: 20,
		// 	iosdelay: 100,
		// 	androiddelay: 100,
		// };
		// this.nativePageTransitions.slide(null);
	}

  setAlternativeStyleState(state: boolean): void {
    this.alternativeStyleSubject.next(state);
    if(state) {
      localStorage.setItem("appAlternativeStyle", JSON.stringify(state));
    }
  }

  getAlternativeStyleState(): boolean | null {
    return this.alternativeStyleSubject.getValue();
  }

	public get rutaImagen(): string {
		return this.ruta_imagen;
	}
	public set rutaImagen(v: string) {
		this.ruta_imagen = v;
	}

	public get mod_eval(): any {
		return this.mod_evaluaciones;
	}

	public get timeC(): any {
		return this.timeCod;
	}

	public get _pages(): any {
		return this.finalMenu;
	}

	getPaginas(): Observable<any[]> {
		return this.pages$.asObservable();
	}

	async cargarFunciones() {
		this.timeCod = 2000;

		this.up.load_storage();

		let config_data = JSON.parse(this.up.getConfigData);
		this.pages = [];
		this.mainPages = [];

		// Plataforma "Desempeño": mientras no exista config de backend, el menú se
		// arma hardcodeado en el front y tiene prioridad sobre capacitación/inducción.
		if (localStorage.getItem("isPerformanceAccessSelected") === "true") {
			this.buildPerformanceMenus();
			return;
		}

		let data_usuario = JSON.parse(localStorage.getItem("user_data"));
		let sidemenu = {} as any;
		if(data_usuario?.user_induccion_aprendizaje)  sidemenu = this.up.getPlatformType === 'induction' ? config_data?.full_app_side_menu_induccion : config_data?.full_app_side_menu;
		else sidemenu = config_data?.full_app_side_menu;

		// if (sidemenu.perfil) {
		// 	this.pages.push({ name: "Anuncios", path: "anuncios", icon: "assets/icon/anuncios.svg" });
		// }
    if(!sidemenu) {
      sidemenu = {};
    }

		if (sidemenu.cursos) {
			this.pages.push({
				name: this.language === 'es' ? "Cursos" : "Courses",
				path: "cursos",
				icon: "assets/icon/book-open-variant.svg",
				group: "courses",
			});
		}
		if (sidemenu.cursosextra) {
			this.pages.push({
				name:  this.language === 'es' ? "Extracurriculares" : "Extracurricular",
				path: "extracurricular",
				icon: "assets/icon/book-account.svg",
				group: "courses"
			});
		}
		if (sidemenu.cursoslibres) {
			this.pages.push({
				name: this.language === 'es' ? "Libres" : "Elective Courses",
				path: "libres",
				icon: "assets/icon/book-heart.svg",
				group: "courses"
			});
		}

    if (sidemenu.cursos || sidemenu.cursosextra || sidemenu.cursoslibres) {
      this.courseIsActive.next(true);
    } else {
      this.courseIsActive.next(false);
    }

		// if (sidemenu.progreso) {
		// 	this.pages.push({
		// 		name: "Progreso",
		// 		path: "progreso",
		// 		icon: "assets/icon/progreso.svg",
		// 		group: "",
		// 	});
		// }
		if (sidemenu.videoteca) {
			this.pages.push({
				name: this.language === 'es' ? "Videoteca" : "video library",
				path: "videoteca",
				icon: "assets/icon/file-video.svg",
				group: "content",
			});
		}
		if (sidemenu.glosario) {
			this.pages.push({
				name: this.language === 'es' ? "Glosario" : "Glossary",
				path: "glosario",
				icon: "assets/icon/alphabetical-variant.svg",
				group: "content",
			});
		}
		if (sidemenu.vademecun) {
			if (JSON.parse(localStorage.getItem("user_data")).workspace.slug === "farmacias-peruanas") {
				this.pages.push({
					name: "Vademécum",
					path: "vademecum",
					icon: "assets/icon/book-education.svg",
					group: "content",
				});
			} else {
				this.pages.push({
					name: this.language === 'es' ? "Documentos y protocolos" : "Documents and protocols",
					path: "documentos-y-protocolos",
					icon: "assets/icon/book-education.svg",
					group: "content",
				});
			}
		}

		if (sidemenu.beneficios) {
			this.pages.push({
				name: this.language === 'es' ? "Mis beneficios" : "My benefits",
				path: "beneficios",
				icon: "assets/icon/gift-open.svg",
				group: "benefits",
			});
		}
		if (sidemenu.progreso) {
			this.pages.push({
				name: this.language === 'es' ? "Progreso" : "Progress",
				path: "progreso",
				icon: "assets/icon/chart-areaspline-variant.svg",
				group: "progress",
			});
		}
		if (sidemenu.calendar) {
      this.pages.push({
        name: this.language === 'es' ? "Actividades" : "Activities",
        path: this.calendarIsAvailable ? "calendar-pending-activities/calendar" : "calendar-pending-activities/pending-activity",
        icon: "assets/icon/calendar-heart.svg",
        group: "progress",
      });
		}
		if (sidemenu.diplomas) {
			this.pages.push({
				name: this.language === 'es' ? "Certificados" : "Certificates",
				path: "certificados",
				icon: "assets/icon/certificate.svg",
				group: "progress",
			});
		}
		if (sidemenu.ranking) {
			this.pages.push({
				name: "Ranking",
				path: "ranking",
				icon: "assets/icon/podium-gold.svg",
				group: "progress",
			});

      this.rankingIsActive.next(true);
		} else {
      this.rankingIsActive.next(false);
    }

		if (sidemenu.historico) {
			this.pages.push({
				name: this.language === 'es' ? "Historial" : "History",
				path: "historial-de-cursos",
				icon: "assets/icon/clock-star-four-points.svg",
				group: "progress",
			});
		}

		/* if (sidemenu.temas_libres) {
			this.pages.push({ name: "Temas Libres", path: "temas_libres" });
		} */
		if (sidemenu.tareas) {
			this.pages.push({
				name: this.language === 'es' ? "Tareas" : "Tasks",
				path: "tareas",
				icon: "assets/icon/book-arrow-down.svg",
				group: "activities",
			});
		}
		if (sidemenu.aulas_virtuales) {
			this.pages.push({
				name:  this.language === 'es' ? "Sesiones live" : "Live sessions",
				path: "lista-reuniones",
				icon: "assets/icon/video.svg",
				group: "activities",
			});
		}
		if (sidemenu.encuestas_libres) {
			this.pages.push({
				name:  this.language === 'es' ? "Encuestas" : "Surveys",
				path: "encuesta-libre",
				icon: "assets/icon/text-box-check.svg",
				group: "activities",
			});
		}
		if (sidemenu.subir_link) {
			this.pages.push({
				name: this.language === 'es' ? "Adjuntar archivo" : "Attach file",
				path: "adjuntar-archivo",
				icon: "assets/icon/clipboard-arrow-up.svg",
				group: "activities",
			});
		}
		// ⚠️ TODO(api): backend todavía no manda la llave del roleplay en
		// `full_app_side_menu`. Mientras tanto se fuerza con MOSTRAR_ROLEPLAYS para
		// poder recorrer la vista; al llegar la llave real, borrar esa constante y
		// dejar solo `sidemenu.roleplays`.
		if (sidemenu.roleplays ) {
			this.pages.push({
				name: this.language === 'es' ? "Roleplays" : "Roleplays",
				path: "roleplays",
				icon: "assets/icon/drama-masks.svg",
				group: "activities",
			});
		}

		if (sidemenu.checklist) {
			this.pages.push({
				name: "Checklist",
				path: "lista-checklists",
				icon: "assets/icon/checkbox-multiple-marked.svg",
				group: "supervision",
			});
		}
		if (sidemenu.is_outsourced_administrator) {
			this.pages.push({
				name: this.language === 'es' ? "Admin. de equipo" : "Team Management",
				path: "manage-teams",
				icon: "assets/icon/account-multiple-plus.svg",
				group: "supervision",
			});
		}

		// if (sidemenu.checklist && JSON.parse(localStorage.getItem("user_data")).rol_entrenamiento) {
		// 	if (JSON.parse(localStorage.getItem("user_data")).rol_entrenamiento == "trainer") {
		// 		this.pages.push({
		// 			name: "Mi equipo",
		// 			path: "lista-alumnos",
		// 			icon: "assets/icon/account-group.svg",
		// 			group: "supervision",
		// 		});
		// 	} else {
		// 		this.pages.push({
		// 			name: "Checklist",
		// 			path: "alumno",
		// 			icon: "assets/icon/checkbox-multiple-marked.svg",
		// 			group: "supervision",
		// 		});
		// 	}
		// }

		if (sidemenu.reportes) {
			if (JSON.parse(localStorage.getItem("user_data")).supervisor)
				this.pages.push({
					name: this.language === 'es' ? "Reportes" : "Reports",
					path: "reportes",
					icon: "assets/icon/account-badge.svg",
					group: "supervision",
				});
		}

		if (sidemenu.reconocimiento) {
			this.pages.push({
				name: this.language === 'es' ? "Reconocimiento" : "Recognition",
				path: "modulo-reconocimiento",
				icon: "assets/icon/trophy.svg",
				group: "recognition",
			});
		}
		if (sidemenu.preguntas) {
			this.pages.push({
				name: this.language === 'es' ? "Preguntas frecuentes" : "FAQ",
				path: "faq",
				icon: "assets/icon/frequently-asked-questions.svg",
				group: "help",
			});
		}
		if (sidemenu.ayuda) {
			this.pages.push({
				name: this.language === 'es' ? "Ayuda" : "Help",
				path: "ayuda",
				icon: "assets/icon/handshake.svg",
				group: "help",
			});
		}

		// Inducción
		if (sidemenu.ind_avance) {
			this.pages.push({
				name: this.language === 'es' ? "Avance" : "Progress",
				path: "home",
				icon: "assets/icon/ind-home.svg",
				group: "",
			});
		}
		if (sidemenu.ind_ruta) {
			this.pages.push({
				name: this.language === 'es' ? "Ruta" : "Route",
				path: "home",
				icon: "assets/icon/ind_ruta.svg",
				group: "",
			});
		}
		// if (sidemenu.ind_certificado) {
		// 	this.pages.push({
		// 		name: "Certificado",
		// 		path: "certificados",
		// 		icon: "assets/icon/ind_certificado.svg",
		// 		group: "",
		// 	});
		// }
		if (sidemenu.ind_asistencia) {
			this.pages.push({
				name: this.language === 'es' ? "Inasistencia" : "Absence",
				path: "lista-colaboradores",
				icon: "assets/icon/ind_inasistencia.svg",
				group: "",
			});
		}
		if (sidemenu.ind_procesos) {
			this.pages.push({
				name: this.language === 'es' ? "Procesos" : "Processes",
				path: "procesos",
				icon: "assets/icon/ind_procesos.svg",
				group: "",
			});
		}
		if (sidemenu.ind_faq) {
			this.pages.push({
				name: "FAQ",
				path: "faq",
				icon: "assets/icon/ind_faq.svg",
				group: "",
			});
		}

    // Si es lider (mentor) en inducción
    if (sidemenu.is_mentor_onboarding) {
      this.pages.push({
        name: this.language === 'es' ? "Solicitudes" : "Requests",
        path: "reuniones-pasantia",
        icon: "assets/icon/ind_induccion.svg",
        group: "",
      });
    }

		// Inducción y Aprendizaje
		if (sidemenu.ind_aprendizaje) {
			this.pages.push({
				name: this.language === 'es' ? "Regresar a capacitación" : "Back to training",
				path: "aprendizaje",
				icon: "assets/icon/ind_capacitacion.svg",
				group: "",
			});
		}

		if (sidemenu.ind_induccion) {
			this.pages.push({
				name: this.language === 'es' ? "Supervisar inducción" : "Supervise onboarding",
				path: "induccion",
				icon: "assets/icon/ind_induccion.svg",
				group: "",
			});
		}

		this.groupedPages = [
			{
				groupName: this.language === 'es' ? "Mis cursos" : "My courses" ,
				groupIcon: "assets/icon/book-open-page-variant.svg",
				groupedItems : [],
				isGrouped: true,
        offlineCode: "courses",
			},
			{
				groupName: this.language === 'es' ?  "Mi avance" : "My progress",
				groupIcon: "assets/icon/chart-timeline-variant.svg",
				groupedItems : [],
				isGrouped: true
			},

			{
				groupName: this.language === 'es' ? "Mis actividades" : "My activities",
				groupIcon: "assets/icon/clipboard-account.svg",
				groupedItems : [],
				isGrouped: true
			},
			{
				groupName: this.language === 'es' ? "Mis beneficios" : "My benefits",
				groupIcon: "assets/icon/gift-open.svg",
				groupedItems : [],
				isGrouped: false
			},
			{
				groupName:  this.language === 'es' ?  "Supervisión" : "Supervision",
				groupIcon: "assets/icon/book-edit.svg",
				groupedItems : [],
				isGrouped: true,
        offlineCode: "checklist",
			},

			{
				groupName: this.language === 'es' ? "Reconocimiento" : "",
				groupIcon: "assets/icon/trophy.svg",
				groupedItems : [],
				isGrouped: false
			},
			{
				groupName: this.language === 'es' ? "Más recursos" : "More resources",
				groupIcon: "assets/icon/multimedia.svg",
				groupedItems : [],
				isGrouped: true
			},
			{
				groupName:  this.language === 'es' ? "Centro de ayuda" : "Help Center",
				groupIcon: "assets/icon/help-circle.svg",
				groupedItems : [],
				isGrouped: true
			}

		];
		for(let page of this.pages ) {
			if(page.group === "courses"){
				this.groupedPages[0].groupedItems.push(page)
			}
			else if(page.group === "progress"){
				this.groupedPages[1].groupedItems.push(page)
			}

			else if(page.group === "activities"){
				this.groupedPages[2].groupedItems.push(page)
			}
			else if(page.group === "benefits"){
				this.groupedPages[3].groupedItems.push(page)
			}
			else if(page.group === "supervision"){
				this.groupedPages[4].groupedItems.push(page)
			}

			else if(page.group === "recognition"){
				this.groupedPages[5].groupedItems.push(page)
			}
			else if(page.group === "content"){
				//más recursos
				this.groupedPages[6].groupedItems.push(page)
			}
			else if(page.group === "help"){
				this.groupedPages[7].groupedItems.push(page)
			}
			else {
				this.groupedPages.push({'groupedItems': [page]})
			}
		}

		for( let group of this.groupedPages ) {
			if(group.groupedItems.length === 1){
				group.groupName = group.groupedItems[0].name;
				group.groupIcon = group.groupedItems[0].icon;
				group.isGrouped = false;
			}

		}
		this.finalMenu = [];
		for( let group of this.groupedPages ) {
			if(group.groupedItems.length > 0){
				this.finalMenu.push(group);
			}
		}
		// console.log("groupedMenu::",this.finalMenu);


		this.pages$.next(this.finalMenu);
		// this.pages$.next(this.pages);

		let main_menu
		if(data_usuario?.user_induccion_aprendizaje) main_menu = this.up.getPlatformType === 'induction' ? config_data?.full_app_main_menu_induccion : config_data?.full_app_main_menu;
		else main_menu = config_data?.full_app_main_menu;

    if(!main_menu){
      main_menu = {}
    };

		// if (main_menu.anuncios) {
		// 	this.mainPages.push({
		// 		name: "Anuncios",
		// 		path: "anuncios",
		// 		icon: "assets/icon/bullhorn-outline.svg",
		// 		selectedIcon: "assets/icon/bullhorn.svg",
		// 	});
		// }
		if (main_menu.anuncios) {
			this.mainPages.push({
				name: this.language === 'es' ? "Inicio" : "Home",
				path: "anuncios",
				icon: "assets/icon/home-outline.svg",
				selectedIcon: "assets/icon/home.svg",
			});
		}
		if (main_menu.cursos) {
			this.mainPages.push({
				name: this.language === 'es' ? "Cursos" : "Courses",
				path: "cursos",
				icon: "assets/icon/book-open-page-variant-outline.svg",
				selectedIcon: "assets/icon/book-open-page-variant.svg",
			});

      const isActive = this.courseIsActive.getValue();
      if(!isActive) {
        this.courseIsActive.next(true);
      };
		}
		if (main_menu.aulas_virtuales) {
			this.mainPages.push({
				name: this.language === 'es' ? "Sesiones" : "Sessions",
				path: "lista-reuniones",
				icon: "assets/icon/video-outline.svg",
				selectedIcon: "assets/icon/video.svg",
			});
		}
		if (main_menu.progreso) {
			this.mainPages.push({
				name:  this.language === 'es' ?  "Progreso" : "Progress",
				path: "progreso",
				icon: "assets/icon/chart-line.svg",
				selectedIcon: "assets/icon/chart-areaspline-variant.svg",
			});
		}
		if(main_menu.ind_home_sup) {
			this.mainPages.push({
				name: this.language === 'es' ?  "Inicio" : "Home",
				path: "procesos",
				icon: "assets/icon/ind-home.svg",
				selectedIcon: "assets/icon/ind-home.svg",
			});
		}
		if(main_menu.ind_procesos) {
			this.mainPages.push({
				name: this.language === 'es' ?  "Inasistencia" : "Absence",
				path: "lista-colaboradores",
				icon: "assets/icon/ind_nav_inasistencia.svg",
				selectedIcon: "assets/icon/ind_nav_inasistencia_selected.svg",
			});
		}
		if(main_menu.ind_asistencia) {
			this.mainPages.push({
				name:  this.language === 'es' ? "Procesos" : "Processes",
				path: "procesos",
				icon: "assets/icon/ind_nav_procesos.svg",
				selectedIcon: "assets/icon/ind_nav_procesos_selected.svg",
			});
		}
		if(main_menu.ind_home) {
			this.mainPages.push({
				name: this.language === 'es' ? "Inicio" : "Home",
				path: "home",
				icon: "assets/icon/ind-home.svg",
				selectedIcon: "assets/icon/ind-home.svg",
			});
		}
		if(main_menu.ind_ruta) {
			this.mainPages.push({
				name: this.language === 'es' ? "Ruta" : "Route",
				path: "map",
				icon: "assets/icon/ind_nav_ruta.svg",
				selectedIcon: "assets/icon/ind_nav_ruta_selected.svg",
				hideInWeb: true
			});
		}
		if(main_menu.ind_faq) {
			this.mainPages.push({
				name: "FAQ",
				path: "faq",
				icon: "assets/icon/ind-faq.svg",
				selectedIcon: "assets/icon/ind_faq.svg",
			});
		}
		if(main_menu.ind_aprendizaje) {
			this.mainPages.push({
				name: this.language === 'es' ?  "Regresar a capacitación" : "Return to training",
				path: "aprendizaje",
				icon: "assets/icon/ind_capacitacion.svg",
				selectedIcon: "assets/icon/ind_capacitacion.svg",
			});
		}
		if(main_menu.ind_induccion) {
			this.mainPages.push({
				name: this.language === 'es' ? "Supervisar inducción" : "Supervise onboarding",
				path: "induccion",
				icon: "assets/icon/ind_induccion.svg",
				selectedIcon: "assets/icon/ind_induccion.svg",
			});
		}
    if (main_menu.checklist) {
			this.mainPages.push({
				name: this.language === 'es' ? "Checklist" : "Checklist",
				path: "lista-checklists",
				icon: "assets/icon/checkbox-multiple-marked-outline.svg",
				selectedIcon: "assets/icon/checkbox-multiple-marked.svg",
			});
		}
    if (main_menu.beneficios) {
			this.mainPages.push({
				name: this.language === 'es' ? "Beneficios" : "Benefits",
				path: "beneficios",
				icon: "assets/icon/gift-open-outline.svg",
				selectedIcon: "assets/icon/gift-open.svg",
			});
		}
    if (main_menu.calendar) {
			this.mainPages.push({
				name: this.language === 'es' ? "Actividades" : "Activities",
				path: this.calendarIsAvailable ? "calendar-pending-activities/calendar" : "calendar-pending-activities/pending-activity",
				icon: "assets/icon/calendar-heart-outline.svg",
				selectedIcon: "assets/icon/calendar-heart.svg",
			});
		}

		this.appMainMenu.next(this.mainPages);

    this.headerPages.next(this.mainPages);
	}

  /**
   * Arma los menús (lateral y principal) de la plataforma "Desempeño". Es un menú
   * fijo del front (aún no hay config de backend) que se emite por los mismos
   * Subjects que consumen los 4 menús (`pages$`, `appMainMenu`, `headerPages`),
   * por lo que se actualizan reactivamente igual que en capacitación/inducción.
   * El item "Objetivos" usa el path-clave `performance-objectives`, que los menús
   * principales interceptan para abrir un popover en vez de navegar.
   */
  private buildPerformanceMenus() {
    const es = this.language === 'es';
    const calendarPath = this.calendarIsAvailable
      ? "calendar-pending-activities/calendar"
      : "calendar-pending-activities/pending-activity";

    // Menú lateral (side-menu + side-menu-mobile): items simples, no agrupados.
    const sidePages = [
      { name: es ? "Calendario" : "Calendar", path: calendarPath, icon: "assets/icon/calendar-heart.svg", group: "" },
      { name: es ? "Beneficios" : "Benefits", path: "beneficios", icon: "assets/icon/gift-open.svg", group: "" },
    ];
    this.finalMenu = sidePages.map((page) => ({
      groupName: page.name,
      groupIcon: page.icon,
      groupedItems: [page],
      isGrouped: false,
    }));
    this.pages$.next(this.finalMenu);

    // Menú principal (footer-tab + my-header).
    this.mainPages = [
      {
        name: es ? "Inicio" : "Home",
        path: "performance",
        icon: "assets/icon/home-outline.svg",
        selectedIcon: "assets/icon/home.svg",
      },
      {
        name: es ? "Procesos" : "Processes",
        path: "performance/procesos",
        icon: "assets/icon/ind_nav_procesos.svg",
        selectedIcon: "assets/icon/ind_nav_procesos_selected.svg",
      },
      {
        name: es ? "Mis objetivos" : "My objectives",
        path: "performance-objectives",
        icon: "assets/icon/bullseye-arrow.svg",
        selectedIcon: "assets/icon/bullseye-arrow.svg",
      },
      {
        name: es ? "Calendario" : "Calendar",
        path: calendarPath,
        icon: "assets/icon/calendar-heart-outline.svg",
        selectedIcon: "assets/icon/calendar-heart.svg",
      },
    ];
    this.appMainMenu.next(this.mainPages);
    this.headerPages.next(this.mainPages);
  }

  sanitizeHtmlString(htmlString) {
    let textSanitized = "";
    if(!htmlString) {
      return textSanitized;
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    textSanitized = doc.body.textContent;
    return textSanitized;
  }

  getLocationOrigin() {
    const origin = window.location.origin;
    return origin;
  }

  getMultibrandBgSvgImg(brandConfig) {
    this.getBrandColors(brandConfig);

    const primaryColorFormated = this.brandColors.primary
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29")
    .replace(/,/g, "%2C");
    const secondaryColorFormated = this.brandColors.secondary
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29")
    .replace(/,/g, "%2C");
    const tertiaryColorFormated = this.brandColors.tertiary
    .replace(/\(/g, "%28")
    .replace(/\)/g, "%29")
    .replace(/,/g, "%2C");

   const bgSvg = `
    "data:image/svg+xml,%3Csvg viewBox='0 0 1440 527' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_481_1404)'%3E%3Cpath d='M1639.04 627.731L1345.44 119.329C1336.2 103.326 1315.74 97.8452 1299.73 107.087L791.332 400.688C775.329 409.93 769.848 430.394 779.089 446.397L1072.69 954.799C1081.93 970.802 1102.4 976.283 1118.4 967.041L1626.8 673.44C1642.8 664.198 1648.29 643.734 1639.04 627.731Z' fill='${primaryColorFormated}'/%3E%3C/g%3E%3Cpath d='M652.174 8.72394L-36.3217 172.747C-55.604 177.341 -67.5114 196.696 -62.9177 215.978L101.105 904.474C105.699 923.757 125.054 935.664 144.336 931.07L832.832 767.047C852.115 762.454 864.022 743.098 859.429 723.816L695.406 35.32C690.812 16.0377 671.457 4.13026 652.174 8.72394Z' fill='${tertiaryColorFormated}'/%3E%3Cpath d='M878.285 501.227L449.202 55.3438C435.696 41.309 413.37 40.8804 399.335 54.3863L-46.5475 483.469C-60.5822 496.975 -61.011 519.301 -47.505 533.336L381.578 979.219C395.084 993.253 417.41 993.682 431.445 980.176L877.327 551.094C891.362 537.588 891.791 515.261 878.285 501.227Z' fill='${secondaryColorFormated}'/%3E%3Cdefs%3E%3CclipPath id='clip0_481_1404'%3E%3Crect width='748.92' height='748.92' fill='white' transform='translate(730 311.397) rotate(-19.7764)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E"
   `;
   return bgSvg;
  }

  /**
   * Returns the resolved brand palette (rgba strings) used to theme the
   * animated pre-login background SVG. The inline SVG paints its shapes with
   * CSS custom properties, so these values are meant to be assigned to
   * --login-bg-primary / --login-bg-secondary / --login-bg-tertiary.
   * Ready for a future brand-specific config without rebuilding the SVG.
   */
  getMultibrandBgColors(brandConfig) {
    this.getBrandColors(brandConfig);
    return { ...this.brandColors };
  }

  getBrandColors(brandConfig) {
    // let primaryColor = "#dead5d" //orange
    // let secondaryColor = "#a83261" //pink
    // let tertiaryColor = "#a69c8b"; // brown

    let primaryColor = brandConfig.color_primario_app;
    let secondaryColor = brandConfig.color_secundario_app;
    let tertiaryColor = brandConfig.color_terciario_app;
    if(!tertiaryColor) {
      tertiaryColor = brandConfig.color_primario_app;
    }

    let rgb;
    let result_pri;
    let result_sec;
    let result_ter;
    try {
      result_pri = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(primaryColor);
      result_sec = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(secondaryColor);
      result_ter = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(tertiaryColor);
      rgb = {
        rp: parseInt(result_pri[1], 16),
        gp: parseInt(result_pri[2], 16),
        bp: parseInt(result_pri[3], 16),
        rs: parseInt(result_sec![1], 16),
        gs: parseInt(result_sec![2], 16),
        bs: parseInt(result_sec![3], 16),
        rt: parseInt(result_ter![1], 16),
        gt: parseInt(result_ter![2], 16),
        bt: parseInt(result_ter![3], 16),
      };
    } catch (error) {
      result_pri = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec("#5458e9");
      result_sec = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec('#58c1e5');
      result_ter = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec("#5458e9");
      rgb = {
        rp: parseInt(result_pri[1], 16),
        gp: parseInt(result_pri[2], 16),
        bp: parseInt(result_pri[3], 16),
        rs: parseInt(result_sec![1], 16),
        gs: parseInt(result_sec![2], 16),
        bs: parseInt(result_sec![3], 16),
        rt: parseInt(result_ter![1], 16),
        gt: parseInt(result_ter![2], 16),
        bt: parseInt(result_ter![3], 16),
      };
    };

    primaryColor = `rgba(${rgb.rp}, ${rgb.gp}, ${rgb.bp}, 1)`;
    secondaryColor = `rgba(${rgb.rs}, ${rgb.gs}, ${rgb.bs}, 1)`;
    tertiaryColor = brandConfig.color_terciario_app ? `rgba(${rgb.rt}, ${rgb.gt}, ${rgb.bt}, 1)` :  `rgba(${rgb.rt}, ${rgb.gt}, ${rgb.bt}, 0.7)`;

    this.brandColors = {
      primary: primaryColor,
      secondary: secondaryColor,
      tertiary: tertiaryColor
    };
  }

  setUserPlatformVersion(): string {
    let userplatformVersion = "";
    if (!this.appPlatformService.isAppPlatform()) {
      userplatformVersion = environment.WEB_VERSION;
    } else if (this.appPlatformService.isIosHibridApp()) {
      userplatformVersion = environment.APP_VERSION_IOS;
    } else if (this.appPlatformService.isAndroidHibridApp()) {
      userplatformVersion = environment.APP_VERSION_ANDROID;
    };
    return userplatformVersion;
  }

  public setLoadingScreenActiveStatus(status:boolean) {
    this.loadingScreenIsActive.next(status);
  }

  getPercentageAsNumber(value: string = ""): number {
    return parseFloat(value.replace('%', ''));
  }

}
